import React, { useEffect, useState } from 'react'
import { TypeSummeryData } from '../../../services'
import { BarChart3 } from 'lucide-react'

function TypeSummery() {
  const [typeSummery, setTypeSummery] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchTopSummery = async () => {
    try {
      setLoading(true)
      const res = await TypeSummeryData()
      setTypeSummery(res)
    } catch (error) {
      console.error('Error fetching activity logs:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTopSummery()
  }, [])

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-12 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  // Calculate total for percentage
  const total = typeSummery.reduce((sum, item) => sum + (item.count || 0), 0)

  // Color palette for activity types
  const colors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-purple-500',
    'bg-orange-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-teal-500',
    'bg-red-500'
  ]

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-6 mb-6 border border-gray-100">
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-3 rounded-lg mr-4">
          <BarChart3 className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">Activity Type Summary</h2>
          <p className="text-sm text-gray-500">Track and monitor activity types across your platform</p>
        </div>
      </div>

      {typeSummery.length === 0 ? (
        <div className="text-center py-12">
          <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <BarChart3 className="w-8 h-8 text-gray-400" />
          </div>
          <p className="text-gray-500">No activity summary found</p>
        </div>
      ) : (
        <div className="space-y-4">
          {typeSummery.map((item, index) => {
            const percentage = total > 0 ? ((item.count / total) * 100).toFixed(1) : 0
            const colorClass = colors[index % colors.length]
            
            return (
              <div key={index} className="group">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-700 capitalize">
                    {item.activity_type || 'Unknown'}
                  </span>
                  <div className="flex items-center space-x-3">
                    <span className="text-sm text-gray-500">{percentage}%</span>
                    <span className="text-lg font-bold text-gray-800">
                      {item.count?.toLocaleString() || 0}
                    </span>
                  </div>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                  <div
                    className={`${colorClass} h-full rounded-full transition-all duration-500 ease-out`}
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {typeSummery.length > 0 && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="flex items-center justify-between text-sm">
            <span className="font-medium text-gray-600">Total Activities</span>
            <span className="text-xl font-bold text-gray-800">{total.toLocaleString()}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default TypeSummery